module.exports = __webpack_public_path__ + "img/guanyu_yous1@2x.93fb5fc4.png";